import { Routes } from "@angular/router";
import { NoContentComponent } from "./no-content";
import { LoginComponent } from "./auth/login";
import { DashboardComponent } from "./dashboard";
import { Dashboard1Component } from "./manage/dashboard1";
import { UserComponent } from "./manage/users";
import { TicketComponent } from "./manage/ticket";
import { CreateTicketComponent } from "./manage/create-ticket";
// import { ForgotPasswordComponent } from './auth/forgot-password';
// import { ResetPasswordComponent } from './auth/reset-password';
// import { ChangePasswordComponent } from './auth/change-password';
import { DataResolver } from "./app.resolver";

// Authguard service
import { AuthGuard } from "./service/auth-guard.service";
import { TicketLogComponent } from "./manage/ticket-log/ticket-log.component";
import { ReportedSellersComponent } from "./manage/reported-sellers";
import { FlagTicketTresholdCountComponent } from "./manage/flag-ticket-treshold-count";
import { ParseTicketsComponent } from "./manage/parse-tickets/parse-tickets.component";
import { ProvidersComponent } from "./manage/providers/providers.component";

export const ROUTES: Routes = [
  { path: "", redirectTo: "/login", pathMatch: "full" },
  { path: "login", component: LoginComponent },
  // { path: 'forgotpassword', component: ForgotPasswordComponent },
  // { path: 'resetpassword', component: ResetPasswordComponent },
  {
    path: "manage",
    component: DashboardComponent,
    canActivate: [AuthGuard],
    children: [
      { path: "", redirectTo: "users", pathMatch: "full" },
      // { path: 'changepassword', component: ChangePasswordComponent },
      { path: "dashboard", component: Dashboard1Component },
      { path: "users", component: UserComponent },
      { path: "tickets", component: TicketComponent },
      { path: "createticket", component: CreateTicketComponent },
      { path: "parseTickets", component: ParseTicketsComponent },
      { path: "providers", component: ProvidersComponent },
      { path: "ticket-log", component: TicketLogComponent },
      { path: "reported-sellers", component: ReportedSellersComponent },
      {
        path: "flag-ticket-threshold",
        component: FlagTicketTresholdCountComponent,
      },
    ],
  },
  { path: "**", component: NoContentComponent },
];



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./~/angular2-template-loader!./src/app/app.routes.ts